import type { ReactNode } from "react";

export default function EmptyState({ icon, title, body, action }: {
  icon?: ReactNode; title: string; body?: string; action?: ReactNode;
}) {
  return <div className="empty-state">
    {icon && <span className="empty-icon" aria-hidden="true">{icon}</span>}
    <strong>{title}</strong>
    {body && <p>{body}</p>}
    {action}
  </div>;
}
